import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, Select, MenuItem, OutlinedInput, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const DiscountSingleField = props => {
  const { options, label, i, name, handleChangeCallback, prevId, selectedPromotions, value, selectedPromotionsCount, discount, allowMoreThan2PromotionsSelected, hasBigFamilyCard } = props;
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (selectedPromotionsCount > i && discount[i + 1]) {
      return;
    }
    setOpen(true);
  };

  const handleChange = e => {
    handleChangeCallback(e.target.value, i);
  };

  const filteredOptions = () => {
    if (!options) {
      return [];
    }
    const spf = [...selectedPromotions];
    spf.splice(i, 1);
    const kdrSelected = hasBigFamilyCard == 'Posiadam kartę ';
    // Brak wybranej promocji
    if (i == 0) {
      return _.filter(options, op => !spf.includes(op.id));
    } else if (i == 1) {
      const promotion = options.filter(op => op.id == spf[0])[0];
      // Jedna promocja
      if (promotion && promotion.promotions_excluded_from_connecting_with && promotion.can_connect_with_other_promotions) {
        // Wybrane KDR i promocja oraz promocja nie jest kodem rabatowym - idziemy dalej
        if (kdrSelected && !allowMoreThan2PromotionsSelected && !promotion.discount_code && selectedPromotionsCount == 1) {

          return [];
        }

        return options.filter(op => promotion.promotions_excluded_from_connecting_with.includes(op.id) || promotion.promotions_excluded_from_connecting_with.includes(op.id.toString()));

      }

      return [];

    }
    // Ta zmienna warunkuje czy można maksymalnie 2 promocje wybrać (albo 3 jeśli mamy kod rabatowy)
    if (!allowMoreThan2PromotionsSelected) {
      // Jeśli trzecia wybrana promocja to rabat to pozwalamy na wybranie jej
      if (i == 3) {
        const promotion = options.filter(op => op.id == spf[2])[0];
        if (promotion && promotion.discount_code) {
          return [promotion];
        }

        return [];
      }
      // Jeśli jedna z pierwszych dwóch pozycji jest z kodu rabatowego to dajemy możliwość pobrania trzeciej
      const idx0 = options.filter(op => op.id == spf[0])[0];
      const idx1 = options.filter(op => op.id == spf[1])[0];
      if (idx0 && idx1) {
        if ((idx0.discount_code || idx1.discount_code) && i == 2) {
          // Jeśli mamy 2 promocje i KDR to blokujemy dalszy wybór
          if (kdrSelected) {

            return [];
          }
        } else {
          return [];
        }
      }
    }
    // Dla więcej niż 1 promocji
    const prevObj = options.find(item => item.id === prevId);
    if (prevObj && prevObj.can_connect_with_other_promotions) {
      const promotions = options.filter(op => spf.includes(op.id));
      // Wyodrębnij pierwszą tablicę liczb jako referencję
      const firstArray = promotions[0].promotions_excluded_from_connecting_with;

      // Użyj metody filter() do sprawdzenia, czy każda liczba z pierwszej tablicy występuje we wszystkich innych tablicach
      const commonIds = firstArray.filter(number => promotions.every(obj => obj.promotions_excluded_from_connecting_with.includes(number))
      );

      return options.filter(opt => commonIds.includes(opt.id));
    }

    return [];
  };

  const description = () => {
    let s = '';
    if (value && !_.isEmpty(options)) {
      const fil = _.filter(options, o => o.id == value);
      if (fil.length > 0) {
        s = fil[0].description;
      }

      return s;
    }
  };
  const shouldDisableFirstPromotion = () => {
    const firstId = selectedPromotions[0];
    if (!firstId || !options?.length) {
      return false;
    }

    const code = options.find(o => o.id == firstId)?.discount_code;

    return Boolean(code?.trim());
  };

  return (
    !_.isEmpty(filteredOptions()) ? <FormControl sx={{ width: '100%' }}>
      <InputLabel htmlFor={`lab${i}`}>{label}</InputLabel>
      <Select
        disabled={(selectedPromotionsCount > i && discount[i + 1]) || ([0].includes(i) && shouldDisableFirstPromotion()) }
        input={<OutlinedInput id={`lab${i}`} label={label} />}
        sx={{
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.light'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.main'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.dark'
          }
        }}
        value={value || ''}
        onChange={e => handleChange(e)}
        labelId={name}
        open = {open}
        onOpen = {handleOpen}
        onClose = {handleClose}
        IconComponent={_props => {
          const rotate = _props.className.toString().includes('iconOpen');

          return (
            <div>
              { rotate
                ? <div style={{ color: 'red', cursor: 'pointer', marginRight: 5, marginBottom: 5, fontSize: 20 }}>X</div>
                : <div><KeyboardArrowDownIcon
                  style={{ cursor: 'pointer' }}
                  onClick = {handleOpen}
                /></div> }
            </div>
          );
        }}

      >
        <MenuItem value=""><Typography color="green">{t('reset_discounts')}</Typography></MenuItem>
        { _.map(filteredOptions(), (item, key) => (
          <MenuItem style={{ whiteSpace: 'normal' }} key={key} value={item.id} id={item.name} data-description={item.description}>
            {item.name}
          </MenuItem>
        ))
        }
      </Select>
      <Typography color="green">{description()}</Typography>
    </FormControl> : null
  );
};
